import { render } from "./Parser.vue?vue&type=template&id=9895aa02&scoped=true"
import script from "./Parser.vue?vue&type=script&lang=js"
export * from "./Parser.vue?vue&type=script&lang=js"

import "./Parser.vue?vue&type=style&index=0&id=9895aa02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9895aa02"]])

export default __exports__